import Skeleton from '@eversports/klimt-primitives/legacy/Skeleton'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import BannerSection from './BannerSection'
import LayoutContainer from './components/LayoutContainer'

const LoadingMatch = () => {
  return (
    <Stack flexDirection="column" gap={2} sx={{ flex: 1, backgroundColor: 'limelite', minHeight: '100vh' }}>
      <BannerSection />
      <LayoutContainer>
        <Skeleton variant="rectangular" width="100%" height="200px" />
        <Skeleton variant="rectangular" width="100%" height="150px" />
        <Skeleton variant="rectangular" width="100%" height="316px" />
      </LayoutContainer>
    </Stack>
  )
}

export default LoadingMatch
